import React from 'react';
export function Partners() {
  const cards = [{
    title: 'Clinical Workflows',
    desc: 'Help your AI agents power real clinical tasks like prescription renewals, medication reconciliation, eligibility checks, and care coordination.'
  }, {
    title: 'Governance',
    desc: 'Agent identity, scoped permissions, and full audit trails so every action is compliant and traceable. Built for HIPAA from day one.'
  }, {
    title: 'Quality Monitoring',
    desc: 'Evals and observability that catch issues before they reach patients or providers.'
  }];
  const team = [{
    name: 'Aaron Leon',
    role: 'Co-founder, CTO',
    bio: 'Tech lead, Amazon One Medical. Led 50+ engineers on EHR and AI tools serving 1M+ patients.',
    linkedin: 'https://www.linkedin.com/in/aaronleon1/'
  }, {
    name: 'Prabha Dublish',
    role: 'Co-founder, CEO',
    bio: 'First product hire, Grow Therapy ($90M to $3B). Built AI features. Former Meta PM.',
    linkedin: 'https://www.linkedin.com/in/prabhadublish/'
  }];
  return <div className="min-h-screen bg-partners-ink text-partners-paper font-body antialiased selection:bg-partners-signal selection:text-partners-paper" data-id="element-88">
      {/* Nav */}
      <header className="border-b border-partners-paper/10" data-id="element-89">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between" data-id="element-90">
          <a href="/" className="font-heading text-3xl text-partners-paper leading-none" data-id="element-91">
            Hubble
          </a>
          <nav className="flex items-center gap-6" data-id="element-92">
            <a href="/" className="font-body text-sm text-partners-paper/70 hover:text-partners-paper transition-colors" data-id="element-93">
              hubble.ai
            </a>
            <a href="https://calendly.com/prabha-hubble/30min?month=2026-04" target="_blank" rel="noopener noreferrer" className="font-body text-sm bg-partners-signal text-partners-paper px-4 py-2 rounded-md hover:opacity-90 transition-opacity" data-id="element-94">
              Get in Touch
            </a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="border-b border-partners-paper/10" data-id="element-95">
        <div className="max-w-6xl mx-auto px-6 py-24 md:py-32" data-id="element-96">
          <div className="max-w-4xl" data-id="element-97">
            <span className="font-body text-xs tracking-[2px] uppercase text-partners-signal mb-6 block" data-id="element-98">
              Partners
            </span>
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl text-partners-paper leading-[1.05] tracking-[-1px] mb-8" data-id="element-99">
              Helping companies build AI agents in healthcare
            </h1>
            <p className="font-body text-lg md:text-xl text-partners-paper/75 leading-[1.6] max-w-3xl mb-10" data-id="element-100">
              Hubble helps healthcare AI companies set up valuable clinical
              workflows, from e-prescribing to care coordination, with the
              governance and quality monitoring needed to operate responsibly.
            </p>
            <a href="https://calendly.com/prabha-hubble/30min?month=2026-04" target="_blank" rel="noopener noreferrer" className="inline-block font-body text-base bg-partners-signal text-partners-paper px-6 py-3 rounded-md hover:opacity-90 transition-opacity" data-id="element-101">
              Get in Touch
            </a>
          </div>
        </div>
      </section>

      {/* How we help */}
      <section className="border-b border-partners-paper/10" data-id="element-102">
        <div className="max-w-6xl mx-auto px-6 py-20 md:py-24" data-id="element-103">
          <div className="mb-14" data-id="element-104">
            <span className="font-body text-xs tracking-[2px] uppercase text-partners-signal mb-4 block" data-id="element-105">
              How we help
            </span>
            <h2 className="font-heading text-4xl md:text-5xl text-partners-paper tracking-[-0.5px]" data-id="element-106">
              What Hubble brings to the stack
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-partners-paper/10 border border-partners-paper/10 rounded-lg overflow-hidden" data-id="element-107">
            {cards.map((card, i) => <div key={i} className="bg-partners-ink p-8 md:p-10 flex flex-col" data-id="element-108">
                <div className="font-body text-xs text-partners-signal mb-4" data-id="element-109">
                  0{i + 1}
                </div>
                <h3 className="font-heading text-2xl text-partners-paper mb-3" data-id="element-110">
                  {card.title}
                </h3>
                <p className="font-body text-[15px] text-partners-paper/70 leading-[1.6]" data-id="element-111">
                  {card.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Who we work with */}
      <section className="border-b border-partners-paper/10" data-id="element-112">
        <div className="max-w-6xl mx-auto px-6 py-20 md:py-24" data-id="element-113">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10" data-id="element-114">
            <div className="md:col-span-5" data-id="element-115">
              <span className="font-body text-xs tracking-[2px] uppercase text-partners-signal mb-4 block" data-id="element-116">
                Who we work with
              </span>
              <h2 className="font-heading text-3xl md:text-4xl text-partners-paper tracking-[-0.5px]" data-id="element-117">
                Healthcare AI companies building production agents
              </h2>
            </div>
            <div className="md:col-span-7 flex flex-col justify-between gap-10" data-id="element-118">
              <p className="font-body text-[16px] md:text-[17px] text-partners-paper/75 leading-[1.65] max-w-2xl" data-id="element-119">
                We work with healthcare AI companies building clinical agent
                workflows, including ambient documentation, prior authorization,
                care navigation, and prescription management.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Built on trusted data sources */}
      <section className="border-b border-partners-paper/10" data-id="element-120">
        <div className="max-w-6xl mx-auto px-6 py-20 md:py-24" data-id="element-121">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10" data-id="element-122">
            <div className="md:col-span-5" data-id="element-123">
              <span className="font-body text-xs tracking-[2px] uppercase text-partners-signal mb-4 block" data-id="element-124">
                Data partners
              </span>
              <h2 className="font-heading text-3xl md:text-4xl text-partners-paper tracking-[-0.5px]" data-id="element-125">
                Built on trusted data sources
              </h2>
            </div>
            <div className="md:col-span-7 flex flex-col justify-between gap-10" data-id="element-126">
              <p className="font-body text-[16px] md:text-[17px] text-partners-paper/75 leading-[1.65] max-w-2xl" data-id="element-127">
                We partner with the data sources healthcare already relies on,
                ensuring AI workflows are built on compliant, high-quality
                foundations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="border-b border-partners-paper/10" data-id="element-128">
        <div className="max-w-6xl mx-auto px-6 py-20 md:py-24" data-id="element-129">
          <div className="mb-14" data-id="element-130">
            <span className="font-body text-xs tracking-[2px] uppercase text-partners-signal mb-4 block" data-id="element-131">
              Our team
            </span>
            <h2 className="font-heading text-4xl md:text-5xl text-partners-paper tracking-[-0.5px]" data-id="element-132">
              Built by people who've done this before
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-partners-paper/10 border border-partners-paper/10 rounded-lg overflow-hidden" data-id="element-133">
            {team.map((p, i) => <div key={i} className="bg-partners-ink p-8 md:p-10" data-id="element-134">
                <div className="w-12 h-12 rounded-full border border-partners-paper/20 flex items-center justify-center mb-6 font-heading text-lg text-partners-paper/80" data-id="element-135">
                  {p.name.charAt(0)}
                </div>
                <h3 className="font-heading text-2xl text-partners-paper mb-1" data-id="element-136">
                  <a href={p.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-partners-signal transition-colors" data-id="element-137">
                    {p.name}
                  </a>
                </h3>
                <div className="font-body text-sm text-partners-signal mb-4" data-id="element-138">
                  {p.role}
                </div>
                <p className="font-body text-[15px] text-partners-paper/70 leading-[1.6]" data-id="element-139">
                  {p.bio}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer data-id="element-140">
        <div className="max-w-6xl mx-auto px-6 py-16" data-id="element-141">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-12" data-id="element-142">
            <div data-id="element-143">
              <a href="/" className="font-heading text-3xl text-partners-paper leading-none block mb-3" data-id="element-144">
                Hubble
              </a>
              <p className="font-body text-sm text-partners-paper/60 max-w-sm" data-id="element-145">
                The platform for healthcare AI agents.
              </p>
            </div>
            <a href="https://calendly.com/prabha-hubble/30min?month=2026-04" target="_blank" rel="noopener noreferrer" className="inline-block font-body text-base bg-partners-signal text-partners-paper px-6 py-3 rounded-md hover:opacity-90 transition-opacity" data-id="element-146">
              Get in Touch
            </a>
          </div>
          <div className="pt-8 border-t border-partners-paper/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-147">
            <p className="font-body text-xs text-partners-paper/50" data-id="element-148">
              © 2026 Hubble. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}